import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
import HomeView from "../views/HomeView.vue";
import forecastPage from "../views/forecastPage.vue";
import experimentPage from "../views/experimentPage.vue";
import componentPage from "../views/comparePage.vue";
import reasonPage from "../views/reasonPage.vue";
import endPage from "../views/endPage.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/forecast",
    name: "forecast",
    component: forecastPage,
  },
  {
    path: "/experiment",
    name: "experiment",
    component: experimentPage,
  },
  {
    path: "/comparePage",
    name: "comparePage",
    component: componentPage,
  },
  {
    path: "/reasonPage",
    name: "reasonPage",
    component: reasonPage,
  },
  {
    path: "/endPage",
    name: "endPage",
    component: endPage,
  },
];
const router = createRouter({
  history: createWebHashHistory(), // 使用Hash模式=
  routes,
});

export default router;
